import { Component } from 'preact'
import cx from 'classnames'
import { route } from 'preact-router'

import ActionButton from '../../action-button'
import { IconConfirm } from '../../icons/confirm'
import { IconConfirmSolid } from '../../icons/confirm-solid'
import { IconAlert } from '../../icons/alert'
import PriceSummary from '../price-summary'
import s from './hero-section.sass'
import GymCardV2 from '../../gym-card-v2'
import { mapBrpError } from '../helpers'
import guideInputs from '../../../../__guide-inputs.json'

export default class ResultHero extends Component {
  render ({
    successTitle,
    successSubtitle,
    successText,
    emailSentToLabel,
    errorTitle,
    errorSubtitle,
    errorText,
    error,
    price,
    email,
    suggestion,
    inputs,
    addOns,
    addOnsCopy,
    shareUrl
  }) {
    const Icon = error
      ? IconAlert
      : IconConfirm

    const combinedIconClassNames = cx(
      s.icon,
      error && s.error
    )

    const srcData = {
      ...guideInputs,
      upgrade: {
        ...guideInputs.upgrade,
        inputs: (suggestion && suggestion.upgradeableTo.upgradeableMemberships) || []
      }
    }

    return (
      <div className={s.resultHero}>
        <Icon className={combinedIconClassNames} />
        {error
          ? <h1>{errorTitle || 'Betalningen lyckades ej'}</h1>
          : <h1>{successTitle || 'Betalningen lyckades'}</h1>
        }
        <h3>
          {error
            ? (errorSubtitle || 'Något gick fel!')
            : (successSubtitle || 'Välkommen till oss på STC!')}
        </h3>
        <p>
          {error
            ? `${errorText || 'Vi kunde tyvärr inte genomföra ditt köp.'} Felkod: ${error}, ${mapBrpError(error)}`
            : (successText || 'Vad roligt att du nu är medlem på STC. Nedan ser du mer information om ditt medlemskap. Vi ses på gymmet!')}
        </p>

        {error && shareUrl && <div className={s.tryAgain}>
          <ActionButton black label='Försök igen' href={shareUrl} />
        </div>}

        {!error &&
          <div>
            <div class={s.summary}>
              <GymCardV2 className={s.summaryCard} color={suggestion && suggestion.cardColor} text={suggestion && suggestion.title} />
              <ul className={s.summaryList}>
                {/* All the user inputs */}
                {Object.keys(inputs).map((inputKey, key) => {
                  const v = inputs[inputKey] && srcData[inputKey].inputs.find(e => e.value === inputs[inputKey] || (e.id && e.id === inputs[inputKey]))

                  return v
                    ? <li key={`input-${key}`}><IconConfirmSolid /> {v.name || v.title || 'Attribut saknas'} {v.description && typeof v.description === 'string' && `(${v.description})`}</li>
                    : null
                })}

                {/* All the included AddOns */}
                {suggestion && suggestion.includedAddOns.map((addOnKey, key) => {
                  const v = addOnsCopy[addOnKey]
                  return v
                    ? <li key={`included-${key}`}><IconConfirmSolid /> {v.name || v.title || 'Attribut saknas'} {v.description && typeof v.description === 'string' && `(${v.description})`}</li>
                    : null
                })}

                {/* All the user selected AddOns */}
                {addOns.map((addOnKey, key) => {
                  const v = addOnsCopy[addOnKey]

                  return v
                    ? <li key={`selected-${key}`}><IconConfirmSolid /> {v.name || v.title || 'Attribut saknas'} {v.description && typeof v.description === 'string' && `(${v.description})`}</li>
                    : null
                })}
              </ul>
              {price != null && <PriceSummary className={s.summaryPrice} label='Total kostnad' amount={price} />}
            </div>

            <div class={s.getStarted}>
              <p>{emailSentToLabel || 'Alla detaljer om ditt köp och kvitto har skickats till:'}<br /><span className={s.email}>{email}</span></p>
              <ActionButton label='Kom igång!' onClick={() => route('/?sidebar=profile-overview')} />
            </div>
          </div>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./components/signup-flow/step-result/hero-section.js